function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M19 10.86h3v3h-3zM10.5 11h3v3h-3zM2 10.86h3v3H2z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20 4.36v16H4v-16h16m1-1H3v18h18v-18z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M2 2.86h3v3H2zM10.5 2.86h3v3h-3zM19 2.86h3v3h-3zM19 18.86h3v3h-3zM10.5 18.86h3v3h-3zM2 18.86h3v3H2z"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2, _ref3);
};

export default SvgComponent;